import React from 'react';
import { Option } from "modules/forms/hosted/formElements/Combobox";
import useFormFlow from "modules/forms/hooks/useFormFlow";

type Props = {
    name: string;
    id: any;
    label?: string;
    placeholder?: string;
    options: Option[];
}

export default function Select(props: Props) {
    const { values, onChange } = useFormFlow();
    const { name, label, placeholder } = props;
    const options = Array.isArray(props.options) ? props.options : [];

    return (
        <>
            <label htmlFor={props.id}>{label}</label>
            <select id={props.id} value={values[name] ?? ""} onChange={e => onChange(name, e.target.value)}>
                {placeholder && (
                    <option value="" disabled>{placeholder}</option>
                )}

                {options.map((option, index) => (
                    <option key={index} value={option.value}>{option.label}</option>
                ))}
            </select>
        </>
    );
}
